/* tslint:disable */
/* eslint-disable */
/**
 * WeWalk API V2.0
 * Backend service for WeWALK Mobile Applications, written in **TypeScript** and runs on **NodeJS**. Using **MongoDB** for database, **mongoose** for ORM, **Redis Cache** for caching auth tokens. In cloud, runs in Azure App Services (wewalk-backend-v2). For cloud database, it uses MongoDB inside Azure Cosmos DB. For passwordless authentication, Firebase Authentication is used, other than that, users can use email-password sign-in as well. Transportation services are fed by [Azure Maps Mobility Services](https://docs.microsoft.com/en-us/rest/api/maps/mobility) [RAW JSON](/api/v2/documentation) - [Swagger Editor](https://editor.swagger.io) <br><br> Production Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI'/> <br><br>Test Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI-staging'/>
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AssistantRequest } from '../models';
import { AssistantResponse } from '../models';
import { ErrorModelResponse } from '../models';
import { GetAudioToTextPredictionRequest } from '../models';
import { GetTextPredictionRequest } from '../models';
import { TextPredictionResponse } from '../models';
/**
 * PredictionApi - axios parameter creator
 * @export
 */
export const PredictionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dialogflow Assistant
         * @param {AssistantRequest} body Request containing base64 audio or text to be understood via Dialogflow service of Google
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictAssistantPost: async (body: AssistantRequest, contentLanguage?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling predictAssistantPost.');
            }
            const localVarPath = `/predict/assistant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            if (contentLanguage !== undefined && contentLanguage !== null) {
                localVarHeaderParameter['Content-Language'] = String(contentLanguage);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Audio to be translated into text which is going to be used guessing the intent via Microsoft LUIS. language must be sent in header parameter 'content-language'
         * @param {GetAudioToTextPredictionRequest} body Request containing base64 audio to be sent to LUIS to get what it actually means in WeWALK Actions domain.
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictGetAudioToTextPredictionPost: async (body: GetAudioToTextPredictionRequest, contentLanguage?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling predictGetAudioToTextPredictionPost.');
            }
            const localVarPath = `/predict/getAudioToTextPrediction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            if (contentLanguage !== undefined && contentLanguage !== null) {
                localVarHeaderParameter['Content-Language'] = String(contentLanguage);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Text to be guessed via Microsoft LUIS. language must be sent in header parameter 'content-language'
         * @param {GetTextPredictionRequest} body Request containing text to be sent to LUIS to get what it actually means in WeWALK Actions domain.
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictGetTextPredictionPost: async (body: GetTextPredictionRequest, contentLanguage?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling predictGetTextPredictionPost.');
            }
            const localVarPath = `/predict/getTextPrediction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            if (contentLanguage !== undefined && contentLanguage !== null) {
                localVarHeaderParameter['Content-Language'] = String(contentLanguage);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredictionApi - functional programming interface
 * @export
 */
export const PredictionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dialogflow Assistant
         * @param {AssistantRequest} body Request containing base64 audio or text to be understood via Dialogflow service of Google
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async predictAssistantPost(body: AssistantRequest, contentLanguage?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantResponse>> {
            const localVarAxiosArgs = await PredictionApiAxiosParamCreator(configuration).predictAssistantPost(body, contentLanguage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Audio to be translated into text which is going to be used guessing the intent via Microsoft LUIS. language must be sent in header parameter 'content-language'
         * @param {GetAudioToTextPredictionRequest} body Request containing base64 audio to be sent to LUIS to get what it actually means in WeWALK Actions domain.
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async predictGetAudioToTextPredictionPost(body: GetAudioToTextPredictionRequest, contentLanguage?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextPredictionResponse>> {
            const localVarAxiosArgs = await PredictionApiAxiosParamCreator(configuration).predictGetAudioToTextPredictionPost(body, contentLanguage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Text to be guessed via Microsoft LUIS. language must be sent in header parameter 'content-language'
         * @param {GetTextPredictionRequest} body Request containing text to be sent to LUIS to get what it actually means in WeWALK Actions domain.
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async predictGetTextPredictionPost(body: GetTextPredictionRequest, contentLanguage?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextPredictionResponse>> {
            const localVarAxiosArgs = await PredictionApiAxiosParamCreator(configuration).predictGetTextPredictionPost(body, contentLanguage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PredictionApi - factory interface
 * @export
 */
export const PredictionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Dialogflow Assistant
         * @param {AssistantRequest} body Request containing base64 audio or text to be understood via Dialogflow service of Google
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictAssistantPost(body: AssistantRequest, contentLanguage?: string, options?: any): AxiosPromise<AssistantResponse> {
            return PredictionApiFp(configuration).predictAssistantPost(body, contentLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Audio to be translated into text which is going to be used guessing the intent via Microsoft LUIS. language must be sent in header parameter 'content-language'
         * @param {GetAudioToTextPredictionRequest} body Request containing base64 audio to be sent to LUIS to get what it actually means in WeWALK Actions domain.
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictGetAudioToTextPredictionPost(body: GetAudioToTextPredictionRequest, contentLanguage?: string, options?: any): AxiosPromise<TextPredictionResponse> {
            return PredictionApiFp(configuration).predictGetAudioToTextPredictionPost(body, contentLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Text to be guessed via Microsoft LUIS. language must be sent in header parameter 'content-language'
         * @param {GetTextPredictionRequest} body Request containing text to be sent to LUIS to get what it actually means in WeWALK Actions domain.
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictGetTextPredictionPost(body: GetTextPredictionRequest, contentLanguage?: string, options?: any): AxiosPromise<TextPredictionResponse> {
            return PredictionApiFp(configuration).predictGetTextPredictionPost(body, contentLanguage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PredictionApi - object-oriented interface
 * @export
 * @class PredictionApi
 * @extends {BaseAPI}
 */
export class PredictionApi extends BaseAPI {
    /**
     * 
     * @summary Dialogflow Assistant
     * @param {AssistantRequest} body Request containing base64 audio or text to be understood via Dialogflow service of Google
     * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredictionApi
     */
    public predictAssistantPost(body: AssistantRequest, contentLanguage?: string, options?: any) {
        return PredictionApiFp(this.configuration).predictAssistantPost(body, contentLanguage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Audio to be translated into text which is going to be used guessing the intent via Microsoft LUIS. language must be sent in header parameter 'content-language'
     * @param {GetAudioToTextPredictionRequest} body Request containing base64 audio to be sent to LUIS to get what it actually means in WeWALK Actions domain.
     * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredictionApi
     */
    public predictGetAudioToTextPredictionPost(body: GetAudioToTextPredictionRequest, contentLanguage?: string, options?: any) {
        return PredictionApiFp(this.configuration).predictGetAudioToTextPredictionPost(body, contentLanguage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Text to be guessed via Microsoft LUIS. language must be sent in header parameter 'content-language'
     * @param {GetTextPredictionRequest} body Request containing text to be sent to LUIS to get what it actually means in WeWALK Actions domain.
     * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredictionApi
     */
    public predictGetTextPredictionPost(body: GetTextPredictionRequest, contentLanguage?: string, options?: any) {
        return PredictionApiFp(this.configuration).predictGetTextPredictionPost(body, contentLanguage, options).then((request) => request(this.axios, this.basePath));
    }
}
